// Compute the cumulative `left` offset for a sticky column based on the widths
// of preceding sticky+visible columns in the same context. Sticky columns must
// be contiguous at the start of the run, and any sticky column followed by
// another sticky column must declare an explicit `width`.
// Offsets are measured from the scroll container's left edge. A layout that insets the list from it — the
// project Settings tab, whose nav is pinned there — sets `--sticky-left-origin` to shift the whole run over.
export default function stickyLeftOffset(columns, index) {
  if (!columns?.[index]?.sticky) return undefined;
  const widths = columns
    .slice(0, index)
    .filter((c) => c?.sticky && c?.isVisible && c?.width)
    .map((c) => c.width);
  return `calc(var(--sticky-left-origin, 0px) + ${widths.length ? widths.join(' + ') : '0px'})`;
}
